import InfoIcon from '@mui/icons-material/Info';
import { CircularProgress, Typography } from '@mui/material';
import { clsx } from 'clsx';
import React, { memo } from 'react';

import styles from './styles.module.scss';

interface Props {
  description: string;
  title?: string;
  loading?: boolean;
  className?: string;
}

const Component: React.FC<Props> = ({ description, title, loading, className }) => {
  return (
    <div className={clsx(styles.container, className)}>
      {title && (
        <Typography
          color="var(--text-2-color)"
          fontWeight="700"
          lineHeight="20px"
          variant="subtitle1"
        >
          {title}
        </Typography>
      )}
      <div className={styles.container__info}>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <InfoIcon
              sx={{
                color: 'var(--gray-6-color)',
                width: '125px',
                height: '125px',
                mb: '40px',
              }}
            />
            <Typography color="var(--gray-2-color)" lineHeight="19px" variant="subtitle1">
              {description}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export const EmptyData = memo(Component);
